<template>
    <div v-if="show" class="company__scrollable_container" :class="cusClass" :style="{ 'max-width': width, 'max-height': height }" :id="`company__scrollable_box__${uuid}`">
        <div class="input-group">
            <input ref="input" :class="{readonly : (readonly || multiple)}" :placeholder="placeholder" :readonly="multiple || readonly" @click="showList" @blur="onBlur" @focus="onFocus" @keyup="onKeyup($event)" @change="loadData($event)" v-model="keyq" class="company__scrollable_input" :disabled="disabled"/>
            <span v-show="!disabled && showClear" @click="clearData()" class="company__scrollable_icon_clear pi pi-times" :class="`company__scrollable_icon_clear__${uuid}`"></span>
        </div>
        <OverlayPanel :ref="`dropdown-${uuid}`" appendTo="body" :id="`overlay-custom-${uuid}`" :class="`overlay-dropdown-custom`" :style="{ 'max-width': width }">
            <div class="list-group-wrapper" :class="{wrapperDisabled: isLoading}">
                <transition name="fade">
                    <div :id="`scrollable_loading_${uuid}`" class="company__scrollable_loading loading" v-show="isLoading && showItemsList">
                        <span class="fa fa-spinner fa-spin"></span> Loading
                    </div>
                </transition>
                <transition name="p-connected-overlay-multiple" v-if="multiple">
                    <ul class="list-group" :id="`infinite-list-${uuid}`" v-show="showItemsList">
                        <li v-if="!options || options.length == 0" class="list-group-item empty">Không có dữ liệu</li>
                        <li v-else class="list-group-item multiple" :id="`list-group-item--${item[defaultValue]}`" :class="{active : ((multipleValue.filter(f => f[defaultValue] == item[defaultValue])).length > 0)}" @click="choose($event, item, dataValue)" v-for="item in options" :key="`${uuid}-${item[defaultValue]}`">
                            <slot name="label" v-bind="item">{{ item[defaultLabel] }}</slot>
                        </li>
                    </ul>
                </transition>
                <transition name="p-connected-overlay" v-else>
                    <ul class="list-group" :id="`infinite-list-${uuid}`" v-show="showItemsList">
                        <li v-if="!options || options.length == 0" class="list-group-item empty">Không có dữ liệu</li>
                        <li v-else class="list-group-item" :id="`list-group-item--${item[defaultValue]}`" :class="{active : (!$commonFuction.isEmpty(value) && value[defaultValue] == item[defaultValue])}" @click="choose($event, item)" v-for="item in options" :key="`${uuid}-${item[defaultValue]}`">
                            <slot name="label" v-bind="item">{{ item[defaultLabel] }}</slot>
                        </li>
                    </ul>
                </transition>
            </div>
        </OverlayPanel>
    </div>
</template>

<script>
export default {
    name: "DropdownScrollable",
    props:{
        width: {
            type: String,
            default: "100%"
        },
        height: {
            type: String,
            default: "auto"
        },
        disabled: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: "Chọn"
        },
        defaultLabel: {
            type: String,
            default: "name"
        },
        defaultValue: {
            type: String,
            default: "id"
        },
        options: {
            type: Array
        },
        show: {
            type: Boolean,
            default: true
        },
        cusClass: {
            type: String,
            default: ""
        },
        value: {
            type: [Object, Array]
        },
        loading: {
            type: Boolean,
            default: false
        },
        total: {
            type: Number,
            default: 0
        },
        onlyClick:{
            type: Boolean,
            default: false
        },
        limit: {
            type: Number,
            default: 20
        },
        showClear: {
            type: Boolean,
            default: true
        },
        multiple: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            offset: 0,
            offsetOld: 0,
            page: 1,
            keyq: null,
            focused: false,
            showItemsList: false,
            uuid: this.$commonFuction.generateUUID(),
            dataValue: null,
            inputDiv: null,
            multipleValue: [],
            isLoading: this.loading,
            showOverlayWrapper: null,
            overlayDiv: null,
            loadCheckDataValue: false
        }
    },
    watch:{
        async "$props.value"() {
            await this.checkDataValue();
        },
        "loading"() {
            this.isLoading = this.loading;
        },
        async "$props.options"() {
            await this.checkDataValue();
        }
        // "showItemsList"() {
            
        // }
    },
    beforeDestroy() {
        clearInterval(this.overlayDiv);
    },
    async mounted () {
        await this.checkDataValue();
        this.overlayDiv = setInterval(() => {
            this.checkShowHideList();
        }, 1);
        this.$nextTick(() => {
            this.inputDiv = this.$refs.input;
        });
        // Initially load some items.
        if (this.show) {
            this.checkScroll();
        }
    },
    methods: {
        async checkDataValue() {
            var dataValueTmp = null
            if(this.multiple){
                dataValueTmp = this.$commonFuction.isEmptyObject(this.dataValue) ? this.value : this.dataValue;
            }else{
                dataValueTmp = this?.dataValue ?? this.value
            }
            await this.checkValue().then(async (res) => {
                if (res != dataValueTmp) {
                    this.dataValue = await dataValueTmp;
                }
            })
        },
        checkShowHideList() {
            setTimeout(() => {
                const listElm = document.querySelector(`#company__scrollable_box__${this.uuid}`);
                if (listElm) {
                    if (this.$refs[`dropdown-${this.uuid}`].visible) {
                        listElm.classList.add("list-toggle");
                        this.showItemsList = true;
                    } else {
                        listElm.classList.remove("list-toggle");
                        this.showItemsList = false;
                    }
                    const overlayElm = document.querySelector(`#overlay-custom-${this.uuid}`);
                    if (overlayElm) {
                        overlayElm.style.width = `${listElm.clientWidth}px`;
                    }
                }
            }, 10);
        },
        checkScroll() {
            const listElm = document.querySelector(`#infinite-list-${this.uuid}`);
            if (listElm) {
                listElm.addEventListener('scroll', async e => {
                    if((listElm.scrollTop + listElm.clientHeight) >= listElm.scrollHeight) {
                        if (this.options && this.options.length < this.total) {
                            await this.loadMore(e);
                        }
                    }
                });
            }
        },
        async checkValue() {
            if (this.$commonFuction.isEmpty(this.value) || this.value.length == 0) {
                // var keyq = this.keyq;
                return this.clearData();
            }
            var arr_tmp = {};
            return await new Promise((resolve) => {
                setTimeout(() => {
                    if ((!this.$commonFuction.isEmptyObject(this.dataValue) && !this.multiple) || (this.multiple && Array.isArray(this.dataValue) && this.dataValue.length > 0)) {
                        if (this.multiple && Array.isArray(this.dataValue) && this.dataValue.length > 0) {
                            let labelArr = [];
                            this.dataValue.map((m, i) => {
                                if (Object.hasOwn(m, `${this.defaultLabel}`) && m[this.defaultLabel] && this.dataValue.length > 0 && Object.hasOwn(this.dataValue, i) && Object.hasOwn(this.dataValue[i], `${this.defaultLabel}`)) {
                                    labelArr.push(this.dataValue[i][this.defaultLabel]);
                                }
                                const listElm = document.querySelector(`#list-group-item--${m[this.defaultValue]}`);
                                if (listElm && !listElm.classList.contains("active")) {
                                    listElm.dispatchEvent(new Event("click"));
                                }
                            })
                            this.keyq = labelArr.join("; ");
                        }
                        resolve(this.dataValue);
                    }
                    if (this.options && this.value && Object.hasOwn(this.value, `${this.defaultValue}`) && !this.options.filter(f => f[this.defaultValue] != this.value[this.defaultValue])) {
                        this.options.push(this.value);
                    } else {
                        if (this.multiple) {
                            arr_tmp = [];
                            if (Array.isArray(this.value) && this.value.length > 0) {
                                this.value.map(m => {
                                    if (Object.hasOwn(m, `${this.defaultValue}`)) {
                                        var arr_tmp_x = this.options.length > 0 ? this.options.filter(f => f[this.defaultValue] == m[this.defaultValue]) : null;
                                        if(arr_tmp_x && arr_tmp_x[0]){
                                            arr_tmp.push(arr_tmp_x ? arr_tmp_x[0] : m);
                                        }else{
                                            arr_tmp.push(m)
                                        }
                                    }
                                })
                            }
                        } else {
                            if (!this.$commonFuction.isEmptyObject(this.value)) {
                                if (Object.hasOwn(this.value, `${this.defaultValue}`)) {
                                    var arr_tmp_x = this.options.length > 0 ? this.options.filter(f => f[this.defaultValue] == this.value[this.defaultValue]) : null;
                                    arr_tmp = arr_tmp_x ? arr_tmp_x[0] : this.value;
                                }
                            }
                        }
                    }
                    if (this.multiple) {
                        if (arr_tmp.length > 0) {
                            let labelArr = []
                            arr_tmp.map((m, i) => {
                                if (Object.hasOwn(m, `${this.defaultLabel}`) && m[this.defaultLabel] && arr_tmp.length && arr_tmp[i][this.defaultLabel]) {
                                    labelArr.push(arr_tmp[i][this.defaultLabel]);
                                }
                                const listElm = document.querySelector(`#list-group-item--${m[this.defaultValue]}`);
                                if (listElm && !listElm.classList.contains("active")) {
                                    listElm.dispatchEvent(new Event("click"));
                                }
                            })
                            this.keyq = labelArr.join("; ");
                            resolve(this.dataValue);
                        } else {
                            let labelArr = []
                            if (Array.isArray(this.value) && this.value.length > 0) {
                                this.value.map((m, i) => {
                                    if (Object.hasOwn(m, `${this.defaultLabel}`) && m[this.defaultLabel] && this.value.length && this.value[i][this.defaultLabel]) {
                                        labelArr.push(this.value[i][this.defaultLabel]);
                                    }
                                    const listElm1 = document.querySelector(`#list-group-item--${m[this.defaultValue]}`);
                                    if (listElm1 && !listElm1.classList.contains("active")) {
                                        listElm1.dispatchEvent(new Event("click"));
                                    }
                                })
                            }
                            this.keyq = labelArr.join("; ");
                            resolve(this.dataValue);
                        }
                    } else {
                        if (!this.$commonFuction.isEmptyObject(arr_tmp)) {
                            this.keyq = Object.hasOwn(arr_tmp, `${this.defaultLabel}`) && arr_tmp[this.defaultLabel] ? arr_tmp[this.defaultLabel] : null;
                            if (!this.$commonFuction.isEmpty(this.keyq)) {
                                const listElm = document.querySelector(`#list-group-item--${this.value[this.defaultValue]}`);
                                if (listElm && !listElm.classList.contains("active")) {
                                    listElm.dispatchEvent(new Event("click"));
                                }
                                const listElmClear = document.querySelector(`.company__scrollable_icon_clear__${this.uuid}`);
                                if (listElmClear) {
                                    listElmClear.classList.add('active');
                                }
                            }
                            resolve(this.dataValue);
                        } else {
                            this.keyq = Object.hasOwn(this.value, `${this.defaultLabel}`) ? this.value[this.defaultLabel] : this.keyq;
                            resolve(this.dataValue);
                        }
                    }
                    resolve(this.dataValue);
                }, 50);
            }).then((res) => {
                return res;
            });
        },
        checkLoading() {
            this.isLoading = true;
            const optionElm = document.querySelector(`#infinite-list-${this.uuid}`);
            const loadElem = document.querySelector(`#scrollable_loading_${this.uuid}`);
            if (loadElem) {
                loadElem.style.height = `${optionElm.clientHeight}px`;
            }
            setTimeout(() => {
                this.isLoading = false;
            }, 10);
        },
        clearData() {
            this.dataValue = {};
            this.keyq = null;
            const listElm = document.querySelector(`.company__scrollable_icon_clear__${this.uuid}`);
            listElm.classList.remove("active");
            this.offset = 0;
            this.page = 1;
            this.multipleValue = [];
            this.$emit("input", this.dataValue);
            this.$emit('offset', this.offset);
            this.$emit("keyup", this.keyq);
            this.$emit("click", this.keyq);
        },
        hideList(event){
            if (!this.multiple) {
                if (this.$refs[`dropdown-${this.uuid}`]) {
                    this.$refs[`dropdown-${this.uuid}`].hide(event);
                    // this.showItemsList = false;
                }
            }
            
        },
        async showList(event, checkData=true) {
            this.$refs[`dropdown-${this.uuid}`].show(event);
            // this.showItemsList = true;
            setTimeout(() => {
                this.checkScroll();
                if (event != 'keyup') {
                    this.checkLoading();
                }
            }, 10);
            if (checkData) {
                await this.checkDataValue();
            }
        },
        onKeyup(event) {
            this.showList(event, false);
            this.loadData(event);
            event.preventDefault();
        },
        onFocus(event) {
            this.focused = true;
            this.$emit('focus', event);
            event.preventDefault();
        },
        onBlur(event) {
            this.$emit('blur', event);
            setTimeout(() => {
                this.hideList(event);
            }, 150);
            event.preventDefault();
        },
        loadData(e=undefined) {
            if ((e != undefined || e != null) && (e.type == "keyup" || e.type == "change")) {
                // this.checkLoading();
                this.offset = 0;
                this.page = 1;
            }
            // if (this.keyupClear && (e != undefined || e != null) && e.type == "keyup") {
            //     this.dataValue = {};
            // }
            if (this.showClear) {
                const listElm = document.querySelector(`.company__scrollable_icon_clear__${this.uuid}`);
                listElm.classList.remove("active");
                if (this.keyq != undefined && this.keyq != null && this.keyq != "") {
                    // filters.name = this.keyq;
                    listElm.classList.add("active");
                }
            }
            if (this.onlyClick && !this.multiple) {
                if (e.type == "click") {
                    this.$emit('input', this.dataValue);
                }
            } else {
                if (!this.multiple) {
                    if (e.type == "click") {
                        if (this.$commonFuction.isEmptyObject(this.value) || this.value.length == 0 || this.dataValue[this.defaultValue] != this.value[this.defaultValue]) {
                            this.$emit('input', this.dataValue);
                        }
                    } else {
                        this.$emit('input', this.dataValue);
                    }
                } else {
                    this.$emit('input', this.dataValue);
                }
                
            }
            if (this.offset != this.offsetOld) {
                this.$emit('offset', this.offset);
                this.offsetOld = this.offset;
            }
            if (e != undefined || e != null) {
                this.$emit(e.type, this.keyq);
            }
        },
        choose(event, item) {
            // this.$set(this, 'keyq', item[this.defaultLabel]);
            if (this.multiple) {
                var labelArr = [];
                var arrValue = [];
                var arrTmpVal = [];
                var removeValue = [];
                if ((this.multipleValue.filter(f => f[this.defaultValue] == item[this.defaultValue])).length > 0) {
                    removeValue.push(item[this.defaultValue]);
                    this.multipleValue.splice(this.multipleValue.indexOf(item), 1);
                } else {
                    if (event.target.innerText != item[this.defaultLabel]) {
                        item.customLabel = event.target.innerText;
                    }
                    this.multipleValue.push(item);
                }

                if (Array.isArray(this.dataValue) && this.dataValue.length > 0) {
                    this.multipleValue.map(n => {
                        arrValue.push(n[this.defaultValue]);
                    })
                    this.dataValue.map(m => {
                        if (!arrValue.includes(m[this.defaultValue]) && !removeValue.includes(m[this.defaultValue])) {
                            arrTmpVal.push(m);
                        }
                    })
                }

                this.multipleValue.map(m => {
                    labelArr.push(m?.customLabel ?? m[this.defaultLabel]);
                })
                arrTmpVal.map(m => {
                    labelArr.push(m?.customLabel ?? m[this.defaultLabel]);
                })
                this.$set(this, 'keyq', labelArr.join("; "));
                this.dataValue = [...this.multipleValue, ...arrTmpVal];
            } else {
                this.$set(this, 'keyq', event.target.innerText);
                this.dataValue = item;
            }
            this.inputDiv.focus();
            this.loadData(event);
            // event.stopPropagation();
        },
        async loadMore (e) {
            // setTimeout(() => {
                if (this.limit*this.page < this.total && this.options.length < this.total && !this.isLoading) {
                    this.page++;
                    this.offset = (this.page - 1)*this.limit;
                }
                this.loadData(e);
            // }, 500);
            // e.preventDefault();
            await e.stopPropagation();
        }
    }
};
</script>

<stype lang="scss">
.company__scrollable_container {
    /** max-width: 400px; */
    width: 100%;
    position: relative;
    margin: 10px 0;
    .company__scrollable_input {
        width: 100%;
        border-radius: 5px;
        padding: 7px;
        padding-right: 4em;
        outline: none;
        border: 1px solid #a6a6a6;
    }
    .company__scrollable_input.readonly {
        cursor: pointer;
    }
}
.overlay-dropdown-custom:after, .overlay-dropdown-custom:before {
    content: unset;
}
.overlay-dropdown-custom {
    border: unset !important;
    background-color: transparent !important;
    margin: 0;
    // box-shadow: none;
    z-index: 2000 !important;
    border-radius: 0 0px 10px 10px;
    .p-overlaypanel-content {
        padding: 0 !important;
        .list-group {
            max-height: 200px;
            border-radius: 0 0px 10px 10px;
            overflow: auto;
            z-index: 1999;
            // position: absolute;
            width: 100%;
            // box-shadow: 0px 5px 15px 1px #dcdcdc;
            .list-group-item {
                cursor: pointer;
            }
            .list-group-item:hover{
                color: #0086C4;
            }
            .list-group-item.active{
                background-color: #0086C4;
                color: #fff;
            }
            .list-group-item.multiple.active {
                background-color: #fff;
                color: #0086C4;
                font-weight: bold;
                border-color: #eee;
            }
            .list-group-item.multiple.active:after {
                content: "\2713";
                position: absolute;
                right: 1%;
            }
            .list-group-item.empty {
                color: #555;
                cursor: unset;
                text-align: center;
            }
            .list-group-item.empty:hover{
                color: #555;
            }
        }
        .company__scrollable_loading {
            position: absolute;
            width: 100%;
            max-height: 200px;
            z-index: 2000;
            background-color: #00000099;
            text-align: center;
            color: #fff;
            font-weight: bold;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 0 0px 10px 10px;
        }
    }
}
.company__scrollable_container::after {
    content: "\e902";
    height: 10px;
    width: 10px;
    color: #a6a6a6;
    position: absolute;
    top: -0.5em;
    right: 1em;
    margin: auto;
    bottom: 0;
    font-family: 'primeicons';
    // background-color: transparent;
    // border-left: 5px solid transparent;
    // border-right: 5px solid transparent;
    // border-top: 5px solid #a6a6a6;
}

.company__scrollable_container.list-toggle::after {
    transform: rotate(180deg);
    top: 0.5em;
}
.company__scrollable_icon_clear {
    position: absolute;
    right: 0;
    padding-right: 2.5em;
    top: 1em;
    cursor: pointer;
    display: none;
    color: #a6a6a6;
}
.company__scrollable_icon_clear.active {
    display: block;
}
.wrapperDisabled {
    background-color: #00000099;
    cursor: no-drop;
}
</stype>